import { Component, OnInit } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { TranslateService } from "@ngx-translate/core";
import { ErrorService } from "../../../control-core/services/error.service";
import { IActionPanel } from "../../../control-core/shared/panel/panel.component";
import { notify, SUCCESS_NOTIFY } from "../../../control-core/util/notify.util";
import { FormControl, FormGroup } from "@angular/forms";
import { initWaitMe, stopWaitMe } from "../../../control-core/util/waitme.util";
import { CONTROL_APP_CONST } from "../../config/control-app.constant";
import {
  ISimpleTableConfig,
  SimpleTableConfig
} from "../../../control-core/shared/simple-table/simple-table.component";
import { StateService } from "@uirouter/core";

declare let jquery: any;
declare let $: any;

@Component({
  selector: 'app-notificacion',
  templateUrl: './notificacion.component.html'
})
export class NotificacionComponent implements OnInit {

  simpleTableDataConfig: ISimpleTableConfig;

  idNotificacionSel: string = '';

  consultaForm: FormGroup;
  consultando: boolean = false;

  actionsPanel: Array<IActionPanel>;

  _newNotificacion: string = '#_newNotificacion';
  _tblResultadosDiv: string = '#tblResultados';
  _detalleNotificacion: string = '#_detalleNotificacion';

  constructor(private _http: HttpClient,
              private _translate: TranslateService,
              private _state: StateService,
              private _errorService: ErrorService) {
    this.consultaForm = new FormGroup({
      numtrack: new FormControl('')
    });
  }

  ngOnInit() {

    this.simpleTableDataConfig = new SimpleTableConfig();
    this.simpleTableDataConfig.columns = [
      {
        label: "DESTINATARIO_LABEL",
        name: 'destinatario'
      }, {
        label: "PHONE_FIELD_LABEL",
        name: 'destelefono'
      }, {
        label: "DESTINO_LABEL",
        name: 'destino'
      }, {
        label: "NUM_PAQUETES_LABEL",
        name: 'paquetes',
        options: {
          action: (data, row) => {
            this.idNotificacionSel = row.id;

            $(this._detalleNotificacion).modal('show');
          }
        }
      }, {
        label: "DATE_LABEL",
        name: 'created_at'
      },
    ];

    this.consultaNotificaciones();
  }

  consultaNotificaciones() {
    this.consultando = true;
    initWaitMe(this._tblResultadosDiv);
    this._http.get<any[]>(`${CONTROL_APP_CONST.API_URL}notificaciones`,
        {params: this.consultaForm.value})
    /*.pipe(tap(resConsulta => {
      this.nWarehouseEnBodega = resConsulta.filter(warehouse => {
        return (warehouse.estado == '1_EN_BODEGA')
      }).length;
    }))*/
        .subscribe(resConsulta => {
              this.simpleTableDataConfig.data = resConsulta;
              this.consultando = false;
              stopWaitMe(this._tblResultadosDiv);
            },
            resError => {
              this._errorService.manejaError(resError);
              this.consultando = false;
              stopWaitMe(this._tblResultadosDiv);
            });
  }

  initRegisNotifiacion(){
    $(this._newNotificacion).modal('show');
  }

  onNotificacionCread(response) {
    if (response.success) {
      $(this._newNotificacion).modal('hide');
      notify(this._translate.instant(response.msg), SUCCESS_NOTIFY);
      this.consultaNotificaciones();
    } else {
      this._errorService.manejaError(response.msg);
    }
  }

  onWarehouseSel(data) {
    if (data.success) {
      $(this._detalleNotificacion).modal('hide');
      this._state.go("whrdetalle", {nro_whr: data.whr});
    }
  }

  ngOnDestroy() {
    $('.modal').modal('hide');
    $('.modal-backdrop').remove();
  }
}



// WEBPACK FOOTER //
// ./src/app/control-app/views/notificacion/notificacion.component.ts